import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { DATA_LIMIT } from '../../data/constants';
import MatTable from '../Tables/MatTable';
import { crypt, fetchFile, formatDate } from '../../lib/helper';
import { Link, useParams } from 'react-router-dom';
// import { AES, enc } from 'crypto-js';
import CryptoJS from 'crypto-js';
import ApiConfig from '../../config/ApiConfig';
import CustomButton from '../CommonComp/Buttons/CustomButton';
import UpgradeImageOrVideoModal from '../Modals/UpgradeImageOrVideoModal';
import { useDispatch, useSelector } from 'react-redux';
import { userItemsSelector } from '../../redux/user';
import { privllegeUserDownloadImagelistApi, userDownloadImagelistApi } from '../../Services/userApis';
import { toast } from 'react-toastify';

const limit = DATA_LIMIT;

const column = [

  {
    label: 'Image',
    id: 'image_url',
    format: (columnData, rowIndex, formatCallback, arr, errors, row) => (
      <span
        style={{ display: 'inline-block', width: '100%', textAlign: 'center' }}
      >
        <img style={{ maxWidth: 200, maxHeight: 200 }} src={columnData} />
      </span>
    ),
  },
  {
    label: 'Name',
    id: 'image_name',
    format: (columnData) => (<span style={{ display: 'inline-block', whiteSpace: "nowrap", cursor: "pointer" }}>{columnData}</span>)
  },
  {
    label: 'Client',
    id: 'client',
    format: (columnData) => (<span style={{ display: 'inline-block', whiteSpace: "nowrap" }}>{columnData || 'N/A'}</span>)
  },
];

function UserPrivllegeImageDownloadHistory({ isPrivillege }) {
  const [tableListing, setTableListing] = useState([])
  const { singleDownloadPrivillegeImagelistDetail } = useSelector(userItemsSelector);
  const dispatch = useDispatch();
  const { userId } = useParams();
  const [page, setPage] = useState(1);
  const [userData, setUserData] = useState(null);
  const [open, setOpen] = useState(false);

  const handleAdd = (value) => {
    setOpen(value);
  }

  useEffect(() => {
    getDownloadImageListing();
  }, []);

  const getUserDownloadImageList = () => {
    let downloadPayload = {
      page: String(1),
      limit: String(limit),
      user_id: userId
    }
    dispatch(privllegeUserDownloadImagelistApi(userId, downloadPayload))
  }

  const handleDownloadImage = (data) => {
    let planType = "WEB";
    if (data?.quality?.toLowerCase()?.includes("web") || data?.quality === "Extra Small") {
      planType = "WEB";
    }
    if (data?.quality?.includes("LARGE") || data?.quality?.toLowerCase()?.includes("large") || data?.quality?.includes("Large") || data?.quality?.toLowerCase()?.includes("high") || data?.quality?.toLowerCase()?.includes("xxl") || data?.quality?.toLowerCase()?.includes("xl")) {
      planType = "LARGE";
    }
    if (data?.quality?.includes("MEDIUM") || data?.quality?.toLowerCase()?.includes("super")) {
      planType = "MEDIUM";
    }
    if (data?.quality === "Small" || data?.quality === "SMALL" || data?.quality?.toLowerCase()?.includes("small") || data?.quality === "small" || data?.quality?.includes("Medium")
    ) {
      planType = "SMALL";
    }
    planType = "SMALL";
    const encryptedImageName = CryptoJS.AES.encrypt(
      String(data?.image_name),
      process.env.REACT_APP_DOWNLOAD_AES_SECRET_KEY).toString();
    const encryptedShootId = CryptoJS.AES.encrypt(String(data?.shoot_id), process.env.REACT_APP_DOWNLOAD_AES_SECRET_KEY).toString();
    const encryptedImageType = CryptoJS.AES.encrypt(String(planType), process.env.REACT_APP_DOWNLOAD_AES_SECRET_KEY).toString();
    const encryptedPayload = { image_name: encryptedImageName, imageType: encryptedImageType, shootid: encryptedShootId, };


    const fileTypeOfDownload = data?.image_name?.substring(0, 2)?.toLowerCase() == "vd" ? "2" : "1";
    toast.promise(fetchFile(`${ApiConfig.ibdownloadimage}?image_name=${encryptedPayload?.image_name}&image_type=${encryptedPayload?.imageType}&shootid=${encryptedPayload?.shootid}&file_type=${fileTypeOfDownload}`),
      {
        pending: "Downloading your file....",
        success: "Please wait while your Image/s is/are downloading. It may take a few moments.",
        error: "Failed to download file.",
      }

    );

  };

  const getDownloadImageListing = async (params = {}, setPageState = () => { }) => {
    const payload = {
      page: String(1),
      limit: limit,
      user_id: userId,
      ...params,
    };
    dispatch(privllegeUserDownloadImagelistApi(userId, payload));
    if (setPageState) {
      setPageState(Number(payload.page))
    }
  };

  useEffect(() => {
    if (singleDownloadPrivillegeImagelistDetail?.items?.elements?.length >= 0) {
      let data = singleDownloadPrivillegeImagelistDetail?.items?.elements?.map((item) => {
        return {
          Discount: item?.Discount,
          amount: item?.amount,
          order_by: item?.order_by,
          rank: item?.rank,
          shoot_id: item?.image?.shootid,
          user_name: item?.user_name,
          sold_image_id: item?.sold_image_id,
          download_on: item?.Download_on,
          client: item?.client,
          order_id: item?.order_id,
          order: item?.order,
          image_name: item?.image_name,
          quality: item?.quality,
          type: item?.type,
          image_url: `${ApiConfig.BASE_IMAGE_URL}${item?.image?.shootid}/${item?.image?.rank}-${item?.image?.Name}.jpg`,
        }
      })
      setTableListing(data)
    }
  }, [singleDownloadPrivillegeImagelistDetail?.items]);


  const actionBody = (data) => {
    return (
      <>

        <div style={{ display: "flex" }}>

          <CustomButton className="noMinWidth buttonDense" onClick={() => {
            handleDownloadImage(data)
          }} sx={{ padding: '5px 10px', marginRight: 1, fontSize: '12px', bgcolor: 'buttonSecondary.main', color: 'buttonSecondary.contrastText' }}>Download</CustomButton>
        </div>

      </>
    );
  };



  return (
    <>
      {!isPrivillege ? <>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: (theme) => theme.spacing(3), py: (theme) => theme.spacing(2) }}>
          <Typography variant='h3'>User Is not Privileged</Typography>
        </Box>
      </> : <>
        <MatTable
          showCheckbox={false}
          columns={column}
          loading={singleDownloadPrivillegeImagelistDetail?.loading}
          data={tableListing}
          page={page}
          perPage={limit}
          action={actionBody}
          total={singleDownloadPrivillegeImagelistDetail?.items?.totalCount || 0}
          setPage={setPage}
          handlePageChange={(newPage) => {
            getDownloadImageListing({
              page: String(newPage)
            }, setPage)
          }}
          pagination={true}
        />
      </>}
      {open && <UpgradeImageOrVideoModal open={open} handleOpen={handleAdd} userData={userData} userId={userId} handleCartList={handleCartList} />}

    </>
  );
}

export default UserPrivllegeImageDownloadHistory;
